import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { ScrollManager } from './components/ScrollManager';
import { CaseStudyAccessProvider } from './contexts/CaseStudyAccessContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Home } from './pages/Home';
import { KordisCaseStudy } from './pages/KordisCaseStudy';
import { ClearDocsCaseStudy } from './pages/ClearDocsCaseStudy';
import { PalacioCaseStudy } from './pages/PalacioCaseStudy';
import { VendooCaseStudy } from './pages/VendooCaseStudy';
import { BotkeeperCaseStudy } from './pages/BotkeeperCaseStudy';
import { CognitiveBiases } from './pages/CognitiveBiases';
export function App() {
  return <ThemeProvider data-id="element-0" data-mp="2wip6p3k1bk5g">
    <MotionConfig reducedMotion="user" data-id="element-1" data-mp="2wi5m1f302hnq">
      <BrowserRouter data-id="element-2" data-mp="28tmifcuwat1z">
        <ScrollManager data-id="element-3" data-mp="28sutgkvsztko" />
        <CaseStudyAccessProvider data-id="element-4" data-mp="28sbe9bxjfjac">
          <Routes data-id="element-5" data-mp="23vuq4hqc94x9">
            <Route path="/" element={<Home data-id="element-7" data-mp="23v2r0wxj8p28" />} data-id="element-6" data-mp="23u9vks40xlze" />
            <Route path="/work/kordis" element={<KordisCaseStudy data-id="element-9" data-mp="3ikr0s4yore8d" />} data-id="element-8" data-mp="23ti6m04xmmi3" />
            <Route path="/work/clear-docs" element={<ClearDocsCaseStudy data-id="element-11" data-mp="3mlj6wpc9h30f" />} data-id="element-10" data-mp="3ijfthv617oci" />
            <Route path="/work/palacio-de-hierro" element={<PalacioCaseStudy data-id="element-13" data-mp="3mj6jvxrnc2gi" />} data-id="element-12" data-mp="3mkhnnxl3da7m" />
            <Route path="/work/vendoo" element={<VendooCaseStudy data-id="element-15" data-mp="3rcsxbs5mwadd" />} data-id="element-14" data-mp="3rbzmog3k10py" />
            <Route path="/work/botkeeper" element={<BotkeeperCaseStudy data-id="element-17" data-mp="4wv3njt0sf7" />} data-id="element-16" data-mp="5yj0slx59ec" />
            <Route path="/playground/cognitive-biases" element={<CognitiveBiases data-id="element-19" data-mp="2zlv6yuqqp1v2" />} data-id="element-18" data-mp="82ld64660ci" />
            <Route path="*" element={<Home data-id="element-21" data-mp="2zng32ospcsv1" />} data-id="element-20" data-mp="2zmo89g6xiz5t" />
          </Routes>
        </CaseStudyAccessProvider>
      </BrowserRouter>
    </MotionConfig>
    </ThemeProvider>;
}